import styled from '@emotion/styled'
import { Button, Typography } from '@mui/material'
import { Box } from '@mui/system'
import { theme } from 'theme'
import EarIcon from 'assets/icons-color/ear-icon.png'
import { HelloNextURL } from 'constants/externalLink'
import { useResponsive } from 'hooks/useResponsive'

const CustomBox1 = styled(Box)`
  background: white;
  box-shadow: 0px 0px 10px rgba(18, 18, 18, 0.08);
  border-radius: 16px;
  padding: 12px 32px 12px 12px;
  display: flex;
  align-items: center;
  gap: 16px;
  flex-wrap: nowrap;
`

const CustomBox2 = styled(Box)`
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  justify-content: space-between;
  width: 100%;
`

const VerticalBox = styled(Box)`
  min-width: 6px;
  min-height: 80px;
  height: 90%;
  background: ${theme.palette.primary.main};
`

const ImageBox = styled(Box)`
  min-width: 64px;
  min-height: 64px;
  background-color: rgb(227, 97, 57, 0.12);
  display: flex;
  justify-content: center;
  align-items: center;
  border-radius: 100%;
`

const GiveFeedback = () => {
  const { isMobile } = useResponsive()
  return (
    <CustomBox1 sx={{ height: isMobile ? '184px' : '116px' }}>
      <VerticalBox />
      <ImageBox>
        <img src={EarIcon} alt="WarningIcon" width={40} height={40} />
      </ImageBox>
      <CustomBox2>
        <Box
          pt="12px"
          pr="5px"
          minWidth="240px"
          sx={{
            flex: '1 0 240px',
          }}
        >
          <Typography variant="body1" fontWeight={600}>
            We’re all ears!
          </Typography>
          <Typography variant="body2" whiteSpace="normal" paragraph>
            Edge is built for community and by community. Your feedback is
            welcome and highly valued!
          </Typography>
        </Box>

        <Button
          variant="contained"
          sx={{
            height: '48px',
            minWidth: '175px',
            maxWidth: '175px',
            flex: '1 0 175px',
          }}
          onClick={() => window.open(HelloNextURL, '_blank')}
        >
          Give feedback
        </Button>
      </CustomBox2>
    </CustomBox1>
  )
}

export default GiveFeedback
